import React from 'react';
import BrandLoader from './BrandLoader';

const MainCustomLoader = () => <BrandLoader />;

export default MainCustomLoader;
